import { Type } from '@angular/core';

export const COMPONENTS: Record<string, (() => Promise<Type<any>>)> = {
    'View': () => import('./view/view.component').then(m => m.ViewComponent),
    'Grid': () => import('./grid/grid.component').then(m => m.GridComponent),
    'Cell': () => import('./cell/cell.component').then(m => m.CellComponent),
    'Cart': () => import('./cart/cart.component').then(m => m.CartComponent),
    'Pick': () => import('./pick/pick.component').then(m => m.PickComponent),
    'Note': () => import('./note/note.component').then(m => m.NoteComponent),
    'Menu': () => import('./menu/menu.component').then(m => m.MenuComponent),
    'Info': () => import('./info/info.component').then(m => m.InfoComponent),
    'Film': () => import('./film/film.component').then(m => m.FilmComponent),
    'Page': () => import('./page/page.component').then(m => m.PageComponent),
    'Skim': () => import('./skim/skim.component').then(m => m.SkimComponent),
    'Tabs': () => import('./tabs/tabs.component').then(m => m.TabsComponent),
    'Html': () => import('./html/html.component').then(m => m.HtmlComponent),
    'Shop': () => import('./shop/shop.component').then(m => m.ShopComponent),
    'Chip': () => import('./chip/chip.component').then(m => m.ChipComponent),
    'Sign': () => import('./sign/sign.component').then(m => m.SignComponent),
    'Like': () => import('./like/like.component').then(m => m.LikeComponent),
    'Hype': () => import('./hype/hype.component').then(m => m.HypeComponent),
    'Play': () => import('./play/play.component').then(m => m.PlayComponent),
    'Load': () => import('./load/load.component').then(m => m.LoadComponent),
    'Pace': () => import('./pace/pace.component').then(m => m.PaceComponent),
    'Send': () => import('./send/send.component').then(m => m.SendComponent),
    'Fund': () => import('./fund/fund.component').then(m => m.FundComponent),
    'Bill': () => import('./bill/bill.component').then(m => m.BillComponent),
    'Head': () => import('./head/head.component').then(m => m.HeadComponent),
    'Foot': () => import('./foot/foot.component').then(m => m.FootComponent),
    'Slip': () => import('./slip/slip.component').then(m => m.SlipComponent),
    'Tile': () => import('./tile/tile.component').then(m => m.TileComponent),
    'Navi': () => import('./navi/navi.component').then(m => m.NaviComponent),
    'Mrec': () => import('./mrec/mrec.component').then(m => m.MrecComponent),
    'Norm': () => import('./norm/norm.component').then(m => m.NormComponent),
    'Tiny': () => import('./tiny/tiny.component').then(m => m.TinyComponent),
    'Slim': () => import('./slim/slim.component').then(m => m.SlimComponent),
    'Lead': () => import('./lead/lead.component').then(m => m.LeadComponent),
    'Find': () => import('./find/find.component').then(m => m.FindComponent),
    'List': () => import('./list/list.component').then(m => m.ListComponent),
    'Join': () => import('./join/join.component').then(m => m.JoinComponent),
    'Past': () => import('./past/past.component').then(m => m.PastComponent),
    'User': () => import('./user/user.component').then(m => m.UserComponent),
    'Ware': () => import('./ware/ware.component').then(m => m.WareComponent),
    'Bale': () => import('./bale/bale.component').then(m => m.BaleComponent),
    'Deal': () => import('./deal/deal.component').then(m => m.DealComponent),
    'Self': () => import('./self/self.component').then(m => m.SelfComponent),
    'Post': () => import('./post/post.component').then(m => m.PostComponent),
    'Spot': () => import('./spot/spot.component').then(m => m.SpotComponent),
    'Okay': () => import('./okay/okay.component').then(m => m.OkayComponent),
    'Card': () => import('./card/card.component').then(m => m.CardComponent),
    'Case': () => import('./case/case.component').then(m => m.CaseComponent),
    'Pass': () => import('./pass/pass.component').then(m => m.PassComponent),
    'Door': () => import('./door/door.component').then(m => m.DoorComponent),
    'Star': () => import('./star/star.component').then(m => m.StarComponent),
    'Rank': () => import('./rank/rank.component').then(m => m.RankComponent),
    'Rate': () => import('./rate/rate.component').then(m => m.RateComponent),
    'Spec': () => import('./spec/spec.component').then(m => m.SpecComponent),
    'Pomp': () => import('./pomp/pomp.component').then(m => m.PompComponent),
    'Mart': () => import('./mart/mart.component').then(m => m.MartComponent),
    'Fact': () => import('./fact/fact.component').then(m => m.FactComponent),
    'Exit': () => import('./exit/exit.component').then(m => m.ExitComponent),
    'Expo': () => import('./expo/expo.component').then(m => m.ExpoComponent),
    'Tier': () => import('./tier/tier.component').then(m => m.TierComponent),
    'Mall': () => import('./mall/mall.component').then(m => m.MallComponent),
    'Sift': () => import('./sift/sift.component').then(m => m.SiftComponent),
    'Cull': () => import('./cull/cull.component').then(m => m.CullComponent),
    'Ship': () => import('./ship/ship.component').then(m => m.ShipComponent),
    'Done': () => import('./done/done.component').then(m => m.DoneComponent),
    'Doco': () => import('./doco/doco.component').then(m => m.DocoComponent),
    'Gist': () => import('./gist/gist.component').then(m => m.GistComponent),
    'Hint': () => import('./hint/hint.component').then(m => m.HintComponent),
    'Prop': () => import('./prop/prop.component').then(m => m.PropComponent),
    'Halt': () => import('./halt/halt.component').then(m => m.HaltComponent),
    'Slid': () => import('./slid/slid.component').then(m => m.SlidComponent),
    'Side': () => import('./side/side.component').then(m => m.SideComponent),
    'Poll': () => import('./poll/poll.component').then(m => m.PollComponent),
    'Buzz': () => import('./buzz/buzz.component').then(m => m.BuzzComponent),
    'Item': () => import('./item/item.component').then(m => m.ItemComponent),
    'Quiz': () => import('./quiz/quiz.component').then(m => m.QuizComponent),
    'Bulk': () => import('./bulk/bulk.component').then(m => m.BulkComponent),
    'More': () => import('./more/more.component').then(m => m.MoreComponent),
    'Plus': () => import('./plus/plus.component').then(m => m.PlusComponent),
    'Fill': () => import('./fill/fill.component').then(m => m.FillComponent),
    'Vote': () => import('./vote/vote.component').then(m => m.VoteComponent),
    'Game': () => import('./game/game.component').then(m => m.GameComponent),
    'Hall': () => import('./hall/hall.component').then(m => m.HallComponent),
    'Clue': () => import('./clue/clue.component').then(m => m.ClueComponent),
    'Gate': () => import('./gate/gate.component').then(m => m.GateComponent),
    'Pose': () => import('./pose/pose.component').then(m => m.PoseComponent),
    'Sway': () => import('./sway/sway.component').then(m => m.SwayComponent),
    'Pane': () => import('./pane/pane.component').then(m => m.PaneComponent),
    'Pact': () => import('./pact/pact.component').then(m => m.PactComponent),
    'Roll': () => import('./roll/roll.component').then(m => m.RollComponent),
    'Pack': () => import('./pack/pack.component').then(m => m.PackComponent),
    'Unit': () => import('./unit/unit.component').then(m => m.UnitComponent),
    'Mast': () => import('./mast/mast.component').then(m => m.MastComponent),
    'Step': () => import('./step/step.component').then(m => m.StepComponent),
    'Pool': () => import('./pool/pool.component').then(m => m.PoolComponent),
    'Iota': () => import('./iota/iota.component').then(m => m.IotaComponent),
    'Suit': () => import('./suit/suit.component').then(m => m.SuitComponent),
    'Perk': () => import('./perk/perk.component').then(m => m.PerkComponent),
    'Cost': () => import('./cost/cost.component').then(m => m.CostComponent),
    'Wipe': () => import('./wipe/wipe.component').then(m => m.WipeComponent),
    'Snap': () => import('./snap/snap.component').then(m => m.SnapComponent),
    'Href': () => import('./href/href.component').then(m => m.HrefComponent),
    'Pays': () => import('./pays/pays.component').then(m => m.PaysComponent),
    'Ppal': () => import('./ppal/ppal.component').then(m => m.PpalComponent),
    'Brtr': () => import('./brtr/brtr.component').then(m => m.BrtrComponent),
};
